// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import {
    useOrderHistoryDebouncedUpdateDraftParameter,
    useOrderHistoryState,
} from "@store/Framework/Store/Greif/Pages/OrderHistory/OrderHistoryHooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC, useEffect, useMemo, useState } from "react";

export interface OrderHistoryFilterFieldWebOrderNumberProps {}

export interface OrderHistoryFilterFieldWebOrderNumberStyles {
    textField?: TextFieldPresentationProps;
}

export const OrderHistoryFilterFieldWebOrderNumberStyles: OrderHistoryFilterFieldWebOrderNumberStyles = {
    textField: filterDrawerProps.textField,
};

const styles = OrderHistoryFilterFieldWebOrderNumberStyles;

const OrderHistoryFilterFieldWebOrderNumber: FC<OrderHistoryFilterFieldWebOrderNumberProps> = () => {
    const { webOrderNumber } = useOrderHistoryState().draftParameter;
    const debouncedUpdateDraftParameter = useOrderHistoryDebouncedUpdateDraftParameter();
    const [value, setValue] = useState(webOrderNumber);
    const id = useMemo(uniqueId, []);
    const label = translate("Order Upload Reference #");

    useEffect(() => {
        if (value !== webOrderNumber) {
            setValue(webOrderNumber);
        }
    }, [webOrderNumber]);

    return (
        <FilterDrawerSection title={label} labelFor={id}>
            <TextField
                {...styles.textField}
                id={id}
                data-test-selector="orderHistory_filterWebOrderNumber"
                onChange={event => {
                    setValue(event.currentTarget.value);
                    debouncedUpdateDraftParameter({ webOrderNumber: event.currentTarget.value });
                }}
                placeholder={translate("Enter {0}", label)}
                value={value}
            />
        </FilterDrawerSection>
    );
};

export default OrderHistoryFilterFieldWebOrderNumber;
